export default __webpack_public_path__ + "static/GRID22-map-conflict-fr-602e974de338c4ce339608c3ede17758.png";